export default __webpack_public_path__ + "media/images/svg/in_icon-75bc12cc4bf6977a49967897cbd2e722.svg";